import React from 'react';

import { Flex, HStack, Stack } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { Controller } from 'react-hook-form';

import { Input, Select, Divider } from 'components';
import { Datepicker } from 'components/Datepicker';
import { debounceCity, debounceState, debounceViaCep } from 'utils/debounces';
import { maskKm, maskTime } from 'utils/masks';

import BatchesForm from './Batch';
import DriverForm from './Driver';

function AddressForm({ register, control, setValue }) {
  return (
    <Stack
      spacing={4}
      flexDir="column">
      <HStack justify="space-between">
        <Input
          {...register('address.postalCode')}
          viewProps={{ w: '60%' }}
          label="CEP"
          onChange={(e) => {
            const cep = e.target.value;
            debounceViaCep(cep, (data: any) => {
              setValue('address.street', data.logradouro);
              setValue('address.district', data.bairro);
              setValue('address.city', {
                label: data.localidade,
                name: data.localidade,
              });
              setValue('address.state', {
                label: data.uf,
                name: data.uf,
              });
            });
          }}
          placeholder="Ex: 37209-990"
        />
        <Input
          {...register('address.street')}
          viewProps={{ w: '60%' }}
          label="Endereço"
          placeholder="Ex: Rua Eduardo Menezes"
        />
      </HStack>

      <HStack justify="space-between">
        <Input
          {...register('address.number')}
          viewProps={{ w: '37%' }}
          label="Número"
          placeholder="Ex: 000"
        />
        <Input
          {...register('address.complement')}
          viewProps={{ w: '60%' }}
          label="Complemento"
          placeholder="Ex: Bloco 3"
        />
      </HStack>

      <HStack justify="space-between">
        <Input
          viewProps={{ w: '37%' }}
          {...register('address.district')}
          label="Bairro"
          placeholder="Ex: São Mateus"
        />
        <Controller
          control={control}
          name="address.state"
          render={({ field }) => (
            <Select
              {...field}
              label="Estado"
              loadOptions={debounceState}
              viewProps={{ w: '60%' }}
            />
          )}
        />
      </HStack>

      <HStack justify="space-between">
        <Controller
          control={control}
          name="address.city"
          render={({ field }) => (
            <Select
              {...field}
              label="Cidade"
              loadOptions={debounceCity}
              viewProps={{ w: '60%' }}
            />
          )}
        />

      </HStack>
    </Stack>
  );
}

function InfoForm({
  control, register, getValues, setValue, watch,
}) {
  return (
    <Stack spacing={4}>
      <DriverForm
        control={control}
        getValues={getValues}
        setValue={setValue}
        watch={watch}
        drivers={{
          name: 'drivers',
          label: 'Condutores',
        }}
        vehicle={{
          name: 'vehicle',
          label: 'Veículo',
        }}
      />
      <DriverForm
        control={control}
        getValues={getValues}
        setValue={setValue}
        watch={watch}
        except={watch('drivers')}
        drivers={{
          name: 'transhipmentDrivers',
          label: 'Condutores do transbordo',
        }}
        vehicle={{
          name: 'transhipmentVehicle',
          label: 'Veículo',
        }}
      />
      <HStack justify="space-between">
        <Controller
          name="dueAt"
          control={control}
          rules={{
            onChange(event) {
              if (event.target.value.length >= 10) {
                const format = event.target.value.length === 10 ? 'DD/MM/YYYY' : undefined;
                const date = dayjs(event.target.value, format);
                if (date.isValid()) {
                  setValue('dueAt', date);
                }
              }
            },
          }}
          render={({ field }) => (
            <Datepicker
              label="Data de Transbordo"
              placeholder="00/00/0000"
              {...field}
            />
          )}
        />
        <Input
          {...register('dueTime')}
          label="Horário de Transbordo"
          placeholder="00:00"
          onChange={({ target: { value } }) => {
            setValue('dueTime',
              maskTime.resolve(value),
            );
          }}
        />
      </HStack>
      <HStack justify="space-between">
        <Input
          label="KM Previsto"
          {...register('estimatedKm')}
          placeholder="000 Km"
          onChange={({ target: { value } }) => {
            setValue('estimatedKm',
              maskKm.resolve(value),
            );
          }}
        />
        <Input
          label="Volume previsto"
          {...register('estimatedVolume')}
          placeholder="Volume previsto de recebimento de material."
        />
      </HStack>
      <Divider mb={7} />
      <BatchesForm
        name="collectActivities"
        control={control}
        watch={watch}
        setValue={setValue}
      />
    </Stack>
  );
}

export default function Transhipment(form) {
  return (
    <Flex
      mb={2}
      flexDir="column">
      <AddressForm {...form} />
      <Divider mb={8} />
      <InfoForm {...form} />
    </Flex>
  );
}
